import { memo } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// -----------------------------------------------------------------------------

const DataListItem = memo(function DataListItem({
  label,
  children,
}: DataListItemProps): JSX.Element {
  return (
    <Box sx={{ display: "flex", width: "100%" }}>
      <Typography
        variant="body1"
        fontWeight="bold"
        component="span"
        sx={{
          flexBasis: "33%",
          maxWidth: "192px",
          flexShrink: 0,
          pr: 1,
          wordBreak: "break-word",
        }}
      >
        {label}
      </Typography>
      <Box sx={{ wordBreak: "break-word" }}>{children}</Box>
    </Box>
  );
});

export default DataListItem;

// -----------------------------------------------------------------------------

interface DataListItemProps {
  label: string;
  children: React.ReactNode;
}
